import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { CONTRACTION_MRR } from "./exampleData";
import {
  BORDER,
  CHART_NEGATIVE_MUTED,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Contraction MRR by month — the recurring revenue lost when existing customers
 * downgrade, remove seats or drop add-ons without cancelling. Colored as a loss
 * (the app's negative red), landing on the running example's $800 month.
 */
const ContractionMrrChart = () => (
  <MetricChartFrame
    caption="Contraction MRR is lumpy — downgrades arrive in bursts — but sits around $600–$1,100 a month as existing customers move to cheaper plans or shed seats without cancelling. Left unwatched, it erodes retention from underneath."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={CONTRACTION_MRR} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "Contraction MRR"]}
      />
      <Bar
        dataKey="value"
        fill={CHART_NEGATIVE_MUTED}
        radius={[4, 4, 0, 0]}
        isAnimationActive={false}
      >
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default ContractionMrrChart;
